export interface IPaymentContainerState {
  /**User has payment details */
  userHasPaymentDetails: boolean;
  /**card details */
  paymentDetails?: any;
  /**payment draw */
  isPaymentDrawOpen: boolean;
  /**Card Details Drawer */
  isCardDetailsDrawerOpen: boolean;
  /**Delivery/collection times */
  deliveryTimes: BackendTimeSlots[];
  /**Selected order type */
  selectedOrderType: SelectedOrderType | null;
  /**Different stages of the payment page */
  paymentStages: PaymentStages;
  /**Delivery draw */
  isDeliveryDrawOpen: boolean;
  /**The selected table */
  selectedTable: string | null;
  /**The table area name */
  areaName: string | null;
  /** Users delivery address*/
  deliveryAddress: any;
  /**Disabled ids */
  disabledIds: string[];
  /**Collection drawer */
  isCollectionDrawOpen: boolean;
  /**the Selected delivery/collection time */
  selectedTime: BackendTimeSlots | null;
  /**table service drawer */
  isTableServiceDrawOpen: boolean;
  /**flag for updating card details */
  isUpdatingPaymentDetails: boolean;
  /**Sub total cost */
  subTotalCost: number;
  /**Tip price */
  tipTotal: number;
  /**Total cost of everything */
  totalPrice: number;
  /**Transaction fee */
  transactionFee: number;
  /**Is the page loading */
  isLoading: boolean;
  /**message left by the customer */
  message: string;
  deliveryPrice: number;
  postcodeCheckStatus: postcodeCheckStatusType;
  /** Tax amount for cart items or service fee*/
  cartItemTaxAmount: number | null;
  serviceTaxAmount: number | null;
  cartItemInclusiveTaxAmount: number | null;
  sericeTaxInclusiveTaxAmount: number | null;
  deliveryTaxAmount: number | null;
  deliveryInclusiveTaxAmount: number | null;
}
export enum PaymentStages {
  PAYMENT,
  CARDDETAILS,
}
export enum SelectedOrderType {
  CLICK = "COLLECTION",
  TABLE = "TABLE_DELIVERY",
  DELIVERY = "HOME_DELIVERY",
}

export interface IOrderTypesChildren {
  dispatch: Dispatch<any>;
  orderType: SelectedOrderType;
  selectedTime?: BackendTimeSlots;
  deliveryAddress?: deliveryAddress;
  selectedTableNumber?: string;
  selectedTableArea?: string;
}

declare type BackendTimeSlots = {
  collection?: boolean;
  delivery?: boolean;
  time_utc: string;
  venue_time: string;
};
